(function () {
  var roots = document.querySelectorAll('[data-bd-slideshow]');

  roots.forEach(function (root) {
    var track = root.querySelector('[data-bd-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bd-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bd-dot]'));
    var prevBtn = root.querySelector('[data-bd-prev]');
    var nextBtn = root.querySelector('[data-bd-next]');
    var total = slides.length;
    if (!track || !total) return;

    var index = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 5) * 1000;
    var timerId = null;
    var isHovering = false;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function startAutoplay() {
      if (!autoplayEnabled || total < 2) return;
      stopAutoplay();
      timerId = setInterval(function () {
        if (!isHovering) next();
      }, speed);
    }
    function stopAutoplay() {
      if (timerId) clearInterval(timerId);
      timerId = null;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        goTo(di);
        startAutoplay();
      });
    });

    /* Pause on hover */
    root.addEventListener('mouseenter', function () { isHovering = true; });
    root.addEventListener('mouseleave', function () { isHovering = false; });

    /* Keyboard nav when the slideshow itself has focus */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { next(); startAutoplay(); }
    });

    /* Touch swipe */
    var touchStartX = 0;
    var touchDeltaX = 0;
    track.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        stopAutoplay();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchmove',
      function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );
    track.addEventListener('touchend', function () {
      if (Math.abs(touchDeltaX) > 40) {
        if (touchDeltaX < 0) {
          next();
        } else {
          prev();
        }
      }
      startAutoplay();
    });

    goTo(0);
    startAutoplay();
  });
})();